import React from 'react';
import "./Navbar.css";
import { Link } from 'react-router-dom';
import { ReactComponent as Icon1 } from './github-icon1.svg';
import { ReactComponent as Icon2 } from './linkedin-icon1.svg';
import { ReactComponent as Icon3 } from './mail1.svg';
import contact from "../pages/contact.gif"
export default function Navbar() {



  // <p className="link-text"> GitHub:    <a href="https://github.com/avryjacksoncom" > GitHub  </a></p>
  // <p className="link-text"> Linkedin: <a href="https://www.linkedin.com/in/avry-jackson-886529265/"> Linkedin   </a></p>
  // <p className="link-text"> Email:    <a href="mailto:ljackson175@toromail.csudh.edu" >  ljackson175@toromail.csudh.edu  </a></p>

  return (

    <div className= "container-navbar">
          <div className = "logo-container">
              
              <Link to = "/"><img className = "gif-1" src={contact} alt="rainbowgif" /></Link></div>
                                   
              {/* <Link to="/" className = "home-link">Home</Link> */}

      <div className= "navbar-item-container">
                <div className = "items-nav"> 
                  <Link to = "/about" className= "middle-link-text"> About</Link>
                  <Link to = "/experience" className = "middle-link-text">Experience</Link>
                  <Link to = "/projects"  id = "notes" className = "middle-link-text">Projects</Link>
                  {/* <Link to = "/notes" className = "middle-link-text"> Notes</Link> */}

                </div>
          </div>

          <div className = "nav-social-links">
                <a className = "socail-icon-link" href="https://github.com/avryjacksoncom" ><Icon1 className = "logo-settings"></Icon1></a>
                <a  className = "socail-icon-link" href="https://www.linkedin.com/in/avry-jackson-886529265/"><Icon2 className = "logo-settings"></Icon2></a>
                <a className = "socail-icon-link" href="mailto:avry.jackson@hotmail.com"><Icon3 className = "logo-settings"></Icon3></a>
          </div>
   
   
   
   
   
    </div>


  );
}
